module.exports = __webpack_public_path__ + "static/img/2000.1170bb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2000.jpg
// module id = 291
// module chunks = 0